module.exports = __webpack_public_path__ + "static/img/titlepic_en.f394e90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/titlepic_en.png
// module id = MhG8
// module chunks = 1